import React from "react";
import { Typography } from "components/Typography";
import * as styles from "./Features.module.scss";

import { ReactComponent as SGM } from "assets/landingPage/icon-sgm.svg";
import { ReactComponent as SRM } from "assets/landingPage/icon-srm.svg";
import { ReactComponent as TOP4 } from "assets/landingPage/icon-top4.svg";

export type FeatureProps = {
  icon: JSX.Element;
  title: string;
  description: string;
};

export const Features = () => {
  const features: FeatureProps[] = [
    {
      icon: <TOP4 />,
      title: "Top 4 Betting",
      description: "Extra place, every race.",
    },
    {
      icon: <SRM />,
      title: "Same Race Multi",
      description: "Select multiple runners in the same race.",
    },
    {
      icon: <SGM />,
      title: "Same Game Multi",
      description: "Select multiple markets in the same game.",
    },
  ];

  return (
    <div className={styles.featuresContainer}>
      <div className={styles.features}>
        {features.map((feature) => (
          <Feature key={feature.title} {...feature} />
        ))}
      </div>
    </div>
  );
};

const Feature = ({ icon, title, description }: FeatureProps) => {
  return (
    <div className={styles.feature}>
      <div className={styles.icon}>
        <div>{icon}</div>
      </div>
      <Typography variant="h4" noSpacing>
        {title}
      </Typography>
      <Typography noSpacing style={{ textAlign: "center" }}>
        {description}
      </Typography>
    </div>
  );
};
